import PageContextMenu from './PageContextMenu';

export default PageContextMenu;
